import { Outlet, NavLink, Link } from "react-router-dom";

import microsoft_openai from "../../assets/logo_chat_head.png";
import project_logo from "../../assets/logo_project.png";

import github from "../../assets/github.svg";

import styles from "./Layout.module.css";

const Layout = () => {
    return (
        <div className={styles.layout}>
            <header className={styles.header} role={"banner"}>
                <div className={styles.headerContainer}>
                    <Link to="/" className={styles.headerTitleContainer}>
                    {/* <img style={{ width: "500px", height: "auto" }} src={project_logo} /> */}
                    </Link>
                    
                </div>
            </header>

            <Outlet />
        </div>
    );
};

export default Layout;
